import React from "react";
import PropTypes from "prop-types";
import useResponsive from "core/hooks/useResponsive";
import Styles from "./AuthViewLayout.module.scss";
import { OneRow, ThreeRow } from "../../core/layouts";
import variables from "../../themes/base/styles/variables";

const AuthViewLayoutStyle = {
  topSectionStyle: {
    display: "flex",
    alignItems: "center",
  },
  middleSectionStyle: {
    marginTop: variables.marginLg,
    marginBottom: variables.marginQuad,
  },
  sectionStyle: {
    padding: variables.paddingMedium,
    display: "flex",
    alignItems: "center",
  },
};
function AuthViewLayout({
  className,
  style,
  topSection,
  topSectionStyle,
  middleSection,
  bottomSection,
}) {
  const responsive = useResponsive();
  return (
    <>
      {responsive.isMd ? (
        <ThreeRow
          className={Styles["login-view-layout"]}
          topSection={topSection}
          topSectionStyle={{
            ...AuthViewLayoutStyle.topSectionStyle,
            ...topSectionStyle,
          }}
          middleSection={middleSection}
          middleSectionStyle={AuthViewLayoutStyle.middleSectionStyle}
          bottomSection={bottomSection}
        />
      ) : (
        <OneRow
          section={bottomSection}
          sectionStyle={AuthViewLayoutStyle.sectionStyle}
        />
      )}
    </>
  );
}

AuthViewLayout.defaultProps = {
  className: "",
  style: {},
};

AuthViewLayout.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
};

export default AuthViewLayout;
